// Chronological ordering — parses real dates automatically (e.g. "29 de Junio", "4 de Julio")
const MONTHS = { enero: 1, febrero: 2, marzo: 3, abril: 4, mayo: 5, junio: 6, julio: 7, agosto: 8, septiembre: 9, octubre: 10, noviembre: 11, diciembre: 12 };
const WEEKDAYS = { "Miércoles": 1, "Jueves": 2, "Viernes": 3, "Sábado": 4, "Domingo": 5, "Lunes": 6, "Martes": 7 };

const dateOrdinal = (day) => {
  if (!day) return Infinity;
  const m = /^(\d{1,2})\s+de\s+([a-záéíóúñ]+)/i.exec(day.trim());
  if (m) {
    const d = parseInt(m[1], 10);
    const month = MONTHS[m[2].toLowerCase()];
    if (month) return month * 100 + d;
  }
  // Fallback for weekday-named events (kept after dated ones)
  if (WEEKDAYS[day.trim()]) return 9000 + WEEKDAYS[day.trim()];
  return Infinity;
};

export const sortEventsByDay = (events) => {
  return [...events].sort((a, b) => {
    if (a.inactive && !b.inactive) return 1;
    if (!a.inactive && b.inactive) return -1;
    return dateOrdinal(a.day) - dateOrdinal(b.day);
  });
};

const IMG_MATRIX = "https://customer-assets.emergentagent.com/job_a72afb8e-e48b-4d04-9772-52bd121eb5e4/artifacts/drgr4fyj_IMG_4968.webp";
const IMG_OST = "https://customer-assets.emergentagent.com/job_pixel-perfect-432/artifacts/wnp0mtdr_IMG_4964.jpeg";
const IMG_LIBERTY = "https://customer-assets.emergentagent.com/job_pixel-perfect-432/artifacts/q6e9inic_IMG_4130.jpeg";
const IMG_PANDA = "https://customer-assets.emergentagent.com/job_pixel-perfect-432/artifacts/wwpv5gan_IMG_4133.png";
const IMG_KAPITAL = "https://customer-assets.emergentagent.com/job_pixel-perfect-432/artifacts/79h8air7_IMG_4136.png";
const IMG_PANAMA = "https://static.prod-images.emergentagent.com/jobs/a72afb8e-e48b-4d04-9772-52bd121eb5e4/images/be4a780552ca475fcd22793ba09ee4d105d4c4691f2bad3dc26c617525021dc6.png";
const IMG_KARLOVY = "https://static.prod-images.emergentagent.com/jobs/a72afb8e-e48b-4d04-9772-52bd121eb5e4/images/51b374add25967e96ab9698c71abd84fdfc4a3417afd3ed48224c3a185472343.png";
const IMG_MORRISONS = "https://static.prod-images.emergentagent.com/jobs/a72afb8e-e48b-4d04-9772-52bd121eb5e4/images/4b6a3db69c5619e019c66f6696d49139b42f851b2c9c6a94cb11fe757c8096e3.png";
const IMG_MAXXIM = "https://static.prod-images.emergentagent.com/jobs/a72afb8e-e48b-4d04-9772-52bd121eb5e4/images/5141fa067031fcb4e81519cc10912c3c59ade96b47fdc79f68723388b7744c30.png";
const IMG_LAP57 = "https://customer-assets.emergentagent.com/job_a72afb8e-e48b-4d04-9772-52bd121eb5e4/artifacts/s1k747w4_IMG_4951.jpeg";

// NOTE: Ticket prices/states/details are the backend's single source of truth.
// They are fetched at runtime from GET /api/ticket-packages (keyed by event id).
// Here we only define event/venue presentation (name, image, city, date, description).

// ===================== ACTIVE EVENTS =====================

export const recommendedEvents = [
  { id: 10, name: "2 de Julio Matrix", venue: "Matrix", price: 20.0, image: IMG_MATRIX, location: "Berlin, Germany", day: "2 de Julio", description: "Noche de techno en Matrix Berlin", inactive: false },
  { id: 11, name: "3 de Julio Matrix", venue: "Matrix", price: 20.0, image: IMG_MATRIX, location: "Berlin, Germany", day: "3 de Julio", description: "La fiesta continúa en Matrix", inactive: false },
  { id: 12, name: "1 de Julio Ost", venue: "Ost", price: 20.0, image: IMG_OST, location: "Berlin, Germany", day: "1 de Julio", description: "Underground techno en Ost Berlin", inactive: false },
  { id: 13, name: "RailRave x Panamá", venue: "Panamá", price: 20.0, image: IMG_PANAMA, location: "Amsterdam, Netherlands", day: "29 de Junio", description: "RailRave aterriza en Panamá, Amsterdam", inactive: false },
  { id: 14, name: "RailRave x Karlovy", venue: "Karlovy", price: 35.0, image: IMG_KARLOVY, location: "Praga, Czech Republic", day: "4 de Julio", description: "RailRave x Karlovy en Praga", inactive: false },
  { id: 15, name: "RailRave x Karlovy", venue: "Karlovy", price: 20.0, image: IMG_KARLOVY, location: "Praga, Czech Republic", day: "6 de Julio", description: "RailRave x Karlovy en Praga", inactive: false },
  { id: 16, name: "RailRave x Morrison's 2", venue: "Morrison's 2", price: 20.0, image: IMG_MORRISONS, location: "Budapest, Hungary", day: "8 de Julio", description: "RailRave x Morrison's 2 en Budapest", inactive: false },
  { id: 17, name: "Rail Rave x Maxxim", venue: "Maxxim", price: 15.0, image: IMG_MAXXIM, location: "Berlin, Germany", day: "2 de Julio", description: "Rail Rave x Maxxim en Berlín", inactive: false },
  { id: 18, name: "Lap57 · Madrid Race Week", venue: "Universidad Autónoma de Madrid", price: 44.0, image: IMG_LAP57, location: "Madrid, España", day: "12 de Septiembre", description: "Marco Carola, ANOTR y Pawsa + more TBA · F1 Race Week", inactive: false },
  // INACTIVE - Madrid events
  { id: 1, name: "Jueves Liberty", venue: "Liberty", price: 15.0, image: IMG_LIBERTY, location: "Madrid, España", day: "Jueves", description: "Jueves de fiesta en Liberty", inactive: true },
  { id: 2, name: "Viernes Liberty", venue: "Liberty", price: 18.0, image: IMG_LIBERTY, location: "Madrid, España", day: "Viernes", description: "La mejor noche del viernes en Liberty", inactive: true },
  { id: 3, name: "Jueves Panda", venue: "Panda Club", price: 15.0, image: IMG_PANDA, location: "Madrid, España", day: "Jueves", description: "Jueves underground en Panda Club", inactive: true },
  { id: 4, name: "Viernes Panda", venue: "Panda Club", price: 20.0, image: IMG_PANDA, location: "Madrid, España", day: "Viernes", description: "Viernes de fiesta en Panda Club", inactive: true },
  { id: 5, name: "Sábado Panda", venue: "Panda Club", price: 22.0, image: IMG_PANDA, location: "Madrid, España", day: "Sábado", description: "La noche más épica del sábado en Panda", inactive: true },
  { id: 6, name: "Miércoles Teatro Kapital", venue: "Teatro Kapital", price: 18.0, image: IMG_KAPITAL, location: "Madrid, España", day: "Miércoles", description: "Miércoles de música latina en Kapital", inactive: true },
  { id: 7, name: "Jueves Teatro Kapital", venue: "Teatro Kapital", price: 20.0, image: IMG_KAPITAL, location: "Madrid, España", day: "Jueves", description: "Jueves de fiesta en las 7 plantas de Kapital", inactive: true },
  { id: 8, name: "Viernes Teatro Kapital", venue: "Teatro Kapital", price: 25.0, image: IMG_KAPITAL, location: "Madrid, España", day: "Viernes", description: "Viernes épico en Teatro Kapital", inactive: true },
  { id: 9, name: "Sábado Teatro Kapital", venue: "Teatro Kapital", price: 30.0, image: IMG_KAPITAL, location: "Madrid, España", day: "Sábado", description: "La noche más grande de Madrid", inactive: true },
];

// ===================== VENUES =====================

export const venues = [
  {
    id: 4, name: "Matrix", location: "Berlin, Germany", priceFrom: 20.0,
    image: IMG_MATRIX, description: "Legendario club de techno en Berlin", inactive: false,
    events: [
      { id: 10, day: "2 de Julio", name: "2 de Julio Matrix", price: 20.0, venue: "Matrix", location: "Berlin, Germany", description: "Noche de techno en Matrix Berlin", image: IMG_MATRIX, inactive: false },
      { id: 11, day: "3 de Julio", name: "3 de Julio Matrix", price: 20.0, venue: "Matrix", location: "Berlin, Germany", description: "La fiesta continúa en Matrix", image: IMG_MATRIX, inactive: false },
    ],
  },
  {
    id: 5, name: "Ost", location: "Berlin, Germany", priceFrom: 20.0,
    image: IMG_OST, description: "Underground techno club en Berlin", inactive: false,
    events: [
      { id: 12, day: "1 de Julio", name: "1 de Julio Ost", price: 20.0, venue: "Ost", location: "Berlin, Germany", description: "Underground techno en Ost Berlin", image: IMG_OST, inactive: false },
    ],
  },
  {
    id: 6, name: "Panamá", location: "Amsterdam, Netherlands", priceFrom: 20.0,
    image: IMG_PANAMA, description: "RailRave x Panamá en Amsterdam", inactive: false,
    events: [
      { id: 13, day: "29 de Junio", name: "RailRave x Panamá", price: 20.0, venue: "Panamá", location: "Amsterdam, Netherlands", description: "RailRave aterriza en Panamá, Amsterdam", image: IMG_PANAMA, inactive: false },
    ],
  },
  {
    id: 7, name: "Karlovy", location: "Praga, Czech Republic", priceFrom: 20.0,
    image: IMG_KARLOVY, description: "RailRave x Karlovy en Praga", inactive: false,
    events: [
      { id: 14, day: "4 de Julio", name: "RailRave x Karlovy", price: 35.0, venue: "Karlovy", location: "Praga, Czech Republic", description: "RailRave x Karlovy en Praga", image: IMG_KARLOVY, inactive: false },
      { id: 15, day: "6 de Julio", name: "RailRave x Karlovy", price: 20.0, venue: "Karlovy", location: "Praga, Czech Republic", description: "RailRave x Karlovy en Praga", image: IMG_KARLOVY, inactive: false },
    ],
  },
  {
    id: 8, name: "Morrison's 2", location: "Budapest, Hungary", priceFrom: 20.0,
    image: IMG_MORRISONS, description: "RailRave x Morrison's 2 en Budapest", inactive: false,
    events: [
      { id: 16, day: "8 de Julio", name: "RailRave x Morrison's 2", price: 20.0, venue: "Morrison's 2", location: "Budapest, Hungary", description: "RailRave x Morrison's 2 en Budapest", image: IMG_MORRISONS, inactive: false },
    ],
  },
  {
    id: 9, name: "Maxxim", location: "Berlin, Germany", priceFrom: 15.0,
    image: IMG_MAXXIM, description: "Rail Rave x Maxxim en Berlín", inactive: false,
    events: [
      { id: 17, day: "2 de Julio", name: "Rail Rave x Maxxim", price: 15.0, venue: "Maxxim", location: "Berlin, Germany", description: "Rail Rave x Maxxim en Berlín", image: IMG_MAXXIM, inactive: false },
    ],
  },
  {
    id: 10, name: "Universidad Autónoma de Madrid", location: "Madrid, España", priceFrom: 44.0,
    image: IMG_LAP57, description: "Lap57 · Madrid Race Week — Marco Carola, ANOTR y Pawsa", inactive: false,
    events: [
      { id: 18, day: "12 de Septiembre", name: "Lap57 · Madrid Race Week", price: 44.0, venue: "Universidad Autónoma de Madrid", location: "Madrid, España", description: "Marco Carola, ANOTR y Pawsa + more TBA · F1 Race Week", image: IMG_LAP57, inactive: false },
    ],
  },
  // INACTIVE - Madrid
  { id: 1, name: "Liberty", location: "Madrid, Spain", priceFrom: 15.0, inactive: true, image: IMG_LIBERTY, description: "Club de música latina y reggaeton en Madrid", events: [] },
  { id: 2, name: "Panda Club", location: "Madrid, Spain", priceFrom: 15.0, inactive: true, image: IMG_PANDA, description: "Underground vibes en el corazón de Madrid", events: [] },
  { id: 3, name: "Teatro Kapital", location: "Madrid, Spain", priceFrom: 18.0, inactive: true, image: IMG_KAPITAL, description: "7 plantas de pura diversión en Madrid", events: [] },
];

// Per-event share slugs (must match backend EVENT_META slugs)
export const EVENT_SLUGS = {
  10: "matrix-2-julio",
  11: "matrix-3-julio",
  12: "ost-1-julio",
  13: "railrave-panama",
  14: "railrave-karlovy-4-julio",
  15: "railrave-karlovy-6-julio",
  16: "railrave-morrisons-2",
  17: "railrave-maxxim",
  18: "lap57-madrid-race-week",
};

export const slugForEvent = (id) => EVENT_SLUGS[id];

export const eventBySlug = (slug) => {
  const id = Object.keys(EVENT_SLUGS).find((k) => EVENT_SLUGS[k] === slug);
  return id ? recommendedEvents.find((e) => String(e.id) === String(id)) : null;
};
